import { CountryRegistry } from "./registry"
import { TCountryEntry, TPhoneStorage } from "./types"
import { formatBR, isValidBR, toStorageBR } from "./engine.br"
import {
  ensureEngine,
  formatIntl,
  isValidIntl,
  toStorageIntl,
  isEngineLoaded,
} from "./engine"

export type { TCountryEntry, TPhoneStorage } from "./types"

export type TCountryOption = TCountryEntry & { flag: string }

const BR = "BR"

export const countryFlagPath = (iso: string): string =>
  `/assets/icons/countries/1x1/${iso}.svg`

export const countryList = (): TCountryOption[] =>
  CountryRegistry.map((c) => ({ ...c, flag: countryFlagPath(c.iso) }))

export const findCountry = (iso: string): TCountryEntry | undefined =>
  CountryRegistry.find((c) => c.iso === iso)

/**
 * Garante que o motor necessário para o país esteja pronto.
 * Brasil resolve imediatamente — não carrega a biblioteca.
 */
export const ensurePhoneEngine = async (iso: string): Promise<void> => {
  if (iso === BR) return
  await ensureEngine()
}

/** Máscara progressiva. Síncrona — usada em transform do react-hook-form. */
export const formatAsYouType = (value: string, iso: string): string =>
  iso === BR ? formatBR(value) : formatIntl(value, iso)

export const isValidPhone = (value: string, iso: string): boolean =>
  iso === BR ? isValidBR(value) : isValidIntl(value, iso)

/** Converte o formato local digitado nas três colunas do banco. */
export const toStorage = (value: string, iso: string): TPhoneStorage =>
  iso === BR ? toStorageBR(value) : toStorageIntl(value, iso)

export { isEngineLoaded }
